import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AppTitleService {
  private _title: Title = inject(Title);
  private _translate: TranslateService = inject(TranslateService);

  setTitleFromKey(key: string, params?: Record<string, any>): void {
    this._translate.get(key, params).subscribe((localizedTitle: string) => {
      this._title.setTitle(localizedTitle);
    });
  }

  setTitleRaw(title: string): void {
    this._title.setTitle(title);
  }
}


